import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { user_reset } from '../store/reducers/authReducer'
import { socket, initSocket, disconnectSocket } from '../utilies/config'

export const useSocketBanCheck = () => {
    const dispatch = useDispatch()
    const { userInfo } = useSelector(state => state.auth)

    useEffect(() => {
        if (!userInfo?.id) return

        initSocket()

        const handleForceDisconnect = (data) => {
            Swal.fire({
                icon: 'error',
                title: 'Hesabınız Bloklanıb! 🚫',
                html: `
                    <div style="text-align: left; padding: 10px;">
                        <p style="margin-bottom: 10px;">
                            <strong>Səbəb:</strong> 
                            <span style="color: #e53e3e;">${data.reason}</span>
                        </p>
                        <p style="font-size: 14px; color: #718096;">
                            Tarix: ${new Date(data.bannedAt).toLocaleDateString()}
                        </p>
                    </div>
                `,
                confirmButtonColor: '#e53e3e',
                confirmButtonText: 'Bağla',
                allowOutsideClick: false
            }).then(() => {
                disconnectSocket()
                dispatch(user_reset())
                window.location.href = '/login'
            })
        }

        socket.on('force_disconnect', handleForceDisconnect)

        return () => {
            socket.off('force_disconnect', handleForceDisconnect)
        }
    }, [userInfo?.id, dispatch])
}
